<template><div><h1 id="titel-und-akademischer-grad" tabindex="-1"><a class="header-anchor" href="#titel-und-akademischer-grad"><span>Titel und akademischer Grad</span></a></h1>
<p>Titel und akademischer Grad — Definiert Titel und akademischer Grad</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert die möglichen Titel, die zu einer Adresse erfasst werden können. Diese Tabelle dient wie die Tabelle <RouteLink to="/referenz/refs/ft.refdata.anreden.html" title="Einzelanreden">Anreden</RouteLink> der korrekten Generierung von Adresse und Briefanrede in einem Output.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Titel</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Code</dt>
<dd>Kürzel für den Titel (erscheint im Adressfenster)</dd>
<dt>Adresstitel</dt>
<dd>Titel, der beim Ausdrucken der Adresse (Generieren des Outputs) in die [Adrzeile1] mit der [Anrede] kombiniert wird</dd>
<dt>Brieftitel</dt>
<dd>Titel, der bei der Generierung der Briefanrede in die Kombination von [Briefanrede] und [Adressname] aufgenommen wird</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.anreden.html" title="Einzelanreden">Anreden</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.anredecode.html" title="Anredecode">Anredecodes</RouteLink></p>
</div></template>


